import React from 'react';

// Table rendering components. Use renderNode to recurse.
export const Table = ({node, idx, renderNode}) => {
    if (!node) return null;

    // Extract caption and classification from table attrs
    const caption = node?.attrs?.caption;
    const classification = node?.attrs?.classification_access;

    // Derive column widths from the first row's cells (if available)
    const firstRow = (node.content || [])[0];
    const colWidths = (firstRow?.content || []).map(c => {
        const w = c?.attrs?.colwidth?.[0];
        return w ? `${w}px` : undefined;
    });

    return (
        <table
            key={idx}
            style={{
                borderCollapse: 'collapse',
                width: '100%',
                tableLayout: 'fixed'
            }}
        >
            {/* Emit colgroup when we have explicit widths */}
            {colWidths.length > 0 && (
                <colgroup>
                    {colWidths.map((w, i) => (
                        <col key={[idx, i]} style={w ? {width: w} : undefined}/>
                    ))}
                </colgroup>
            )}

            {/* Optional caption (include classification if present) */}
            {caption && (
                <caption style={{textAlign: 'left', fontStyle: 'italic', padding: '4px 0'}}>
                    {classification ? `(${classification}) ` : ''} {caption}
                </caption>
            )}

            <tbody>
            {(node.content || []).map((row, i) => renderNode(row, i, {inTable: true, renderNode}))}
            </tbody>
        </table>
    );
};

export const TableRow = ({node, idx, renderNode}) => {
    if (!node) return null;
    return (
        <tr key={idx}>
            {(node.content || []).map((cell, i) => renderNode(cell, i, {inTable: true, renderNode}))}
        </tr>
    );
};

export const TableCell = ({node, idx, renderNode}) => {
    if (!node) return null;
    const isHeader = node.type === 'tableHeader';
    const Tag = isHeader ? 'th' : 'td';
    const colSpan = (node.attrs && node.attrs.colspan) || 1;
    const rowSpan = (node.attrs && node.attrs.rowspan) || 1;

    // Pick up the first column width (if provided) and apply as inline style
    const colWidth = node?.attrs?.colwidth?.[0];

    return (
        <Tag
            key={idx}
            colSpan={colSpan}
            rowSpan={rowSpan}
            style={{
                border: '1px solid rgba(0,0,0,0.12)',
                padding: '8px',
                textAlign: isHeader ? 'left' : 'inherit',
                verticalAlign: 'top',
                width: colWidth ? `${colWidth}px` : 'auto',
                wordBreak: 'break-word'
            }}
        >
            {(node.content || []).map((c, i) => renderNode(c, i, {inTable: true, renderNode}))}
        </Tag>
    );
};
